import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Values from "./components/Values";
import Services from "./components/Services";
import Products from "./components/Products";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-cream-50 font-sans text-ink-950">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Values />
        <Services />
        <Products />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}